/**
 * Merge fields ({{ad_soyad}}, {{otel}}…) in a voice survey's texts. A call fills them from its
 * list row or CRM event; a browser test has neither, so the tester types the values instead.
 */

const MERGE_FIELD = /\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g;
// Pivony fills these itself on every call.
const RESERVED_FIELDS = ["brand", "pivony_recipient"];
const STORAGE_KEY = "pivony.voiceTestValues";
// For a few minutes on 2026-11-01 testers kept several "test people"; the first one's values carry over.
const PEOPLE_KEY = "pivony.voiceTestPeople";

/** The fields the texts use, in order of first use. */
export const mergeFieldsOf = (...texts) => {
  const names = [];
  texts.forEach((text) => {
    const source = String(text || "");
    const pattern = new RegExp(MERGE_FIELD.source, "g");
    for (let match = pattern.exec(source); match; match = pattern.exec(source)) {
      const name = match[1];
      if (!RESERVED_FIELDS.includes(name) && !names.includes(name)) names.push(name);
    }
  });
  return names;
};

const typed = (values, name) => String((values || {})[name] || "").trim();

/** The test's dynamic variables: the server's, with each typed value in its field. */
export const withTestValues = (serverVariables, values) => {
  const result = { ...(serverVariables || {}) };
  Object.keys(result).forEach((name) => {
    if (!RESERVED_FIELDS.includes(name) && typed(values, name)) result[name] = typed(values, name);
  });
  return result;
};

/** The text with each typed value in place; fields without one stay as written. */
export const fillTestValues = (text, values) =>
  String(text || "").replace(MERGE_FIELD, (field, name) => typed(values, name) || field);

// The tester's values carry over between surveys and visits; storage may be blocked.
const plainObject = (value) => (value && typeof value === "object" && !Array.isArray(value) ? value : {});

export const loadTestValues = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved) return plainObject(JSON.parse(saved));
    const people = JSON.parse(window.localStorage.getItem(PEOPLE_KEY) || "null");
    return Array.isArray(people) && people.length ? plainObject(people[0] && people[0].values) : {};
  } catch (e) {
    return {};
  }
};

export const saveTestValues = (values) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(values || {}));
  } catch (e) {
    // The values still work for this visit.
  }
};
